import CONSTANTS from "@/constants";

const generateSignature = async (secret) => {
    const encoder = new TextEncoder();
    const key = encoder.encode(secret);
    const combinedMessage = new Uint8Array(key.length);
    combinedMessage.set(key);

    const hashBuffer = await crypto.subtle.digest('SHA-256', combinedMessage);

    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

    let signature = hashHex.slice(0, 36);
    signature = signature.replace(/(.{12})(?=.)/g, '$1-');

    return signature;
};

const sendRequest = async (url, email, additionalBody = {}) => {
    const body = JSON.stringify({ user_email: email, ...additionalBody });
    const signature = await generateSignature(process.env.VUE_APP_SECRET_ENV_KEY);

    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-signature': signature,
        },
        body
    });
};

export const createNametagVerificationRequest = async (email) => {
    return sendRequest(`${CONSTANTS.NAMETAG_USER_VERIFICATION_URL}/v1/create-nametag-verification-requests`, email);
};

export const resetPasswordAndMfa = async (email, selectedOption) => {
    return sendRequest(
        `${CONSTANTS.NAMETAG_USER_VERIFICATION_URL}/v1/reset-password-and-mfa`,
        email,
        { action: selectedOption }
    );
};

export const nametagUserVerification = async (email) => {
    return sendRequest(`${CONSTANTS.NAMETAG_USER_VERIFICATION_URL}/v1/get-nametag-verification-status`, email);
};